'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorBibSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _sharedProgressBar = require('@bibliocommons/shared-progress-bar');

var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _searchBar = require('../../search-bar');

var _searchBar2 = _interopRequireDefault(_searchBar);

var _searchResultItem = require('../../search-result-item');

var _searchResultItem2 = _interopRequireDefault(_searchResultItem);

var _searchResults = require('../../search-results');

var _searchResults2 = _interopRequireDefault(_searchResults);

var _itemScreenReaderDescription = require('../../item-screen-reader-description');

var _itemScreenReaderDescription2 = _interopRequireDefault(_itemScreenReaderDescription);

require('../styles/AnchorBibSelector.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnchorBibSelector = exports.AnchorBibSelector = function (_BcReactComponent) {
  _inherits(AnchorBibSelector, _BcReactComponent);

  function AnchorBibSelector(props) {
    _classCallCheck(this, AnchorBibSelector);

    var _this = _possibleConstructorReturn(this, (AnchorBibSelector.__proto__ || Object.getPrototypeOf(AnchorBibSelector)).call(this, props));

    _this.bindAll('handleQueryChange', 'renderSearchResults');
    _this.state = {};
    _this._searchResultItems = {};
    return _this;
  }

  _createClass(AnchorBibSelector, [{
    key: 'handleQueryChange',
    value: function handleQueryChange(newQuery) {
      this.props.handleSearchParameterChange(_immutable2.default.Map({ query: newQuery }));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Set focus on title of next search result added
      if (this.props.searchResults.size > prevProps.searchResults.size) {
        var newSearchResultIndex = prevProps.searchResults.size;
        if (this._searchResultItems && this._searchResultItems[newSearchResultIndex]) {
          this._searchResultItems[newSearchResultIndex].focusOnTitle();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.restoreFocus();
    }
  }, {
    key: 'handleAnchorBibSelected',
    value: function handleAnchorBibSelected(anchorBib) {
      this.props.handleAnchorBibSelected(anchorBib);
    }
  }, {
    key: 'focusOnSearchInput',
    value: function focusOnSearchInput() {
      this.props.captureFocus(this._searchBar, false);
    }
  }, {
    key: 'renderSearchResults',
    value: function renderSearchResults() {
      var _this2 = this;

      var searchResultsFound = this.props.searchResults && this.props.searchResults.size > 0;
      if (searchResultsFound || this.props.searchParams.get('noResultsFound')) {
        return _react2.default.createElement(
          _searchResults2.default,
          {
            searchParams: this.props.searchParams,
            searchResults: this.props.searchResults,
            pageSize: 4 },
          this.props.searchResults.slice(0, this.props.searchParams.get('page') * 4).map(function (item, i) {
            return _react2.default.createElement(
              _searchResultItem2.default,
              {
                key: i,
                item: item,
                ref: function ref(el) {
                  return _this2._searchResultItems[i] = el;
                },
                listItems: _this2.props.listItems },
              _react2.default.createElement(
                _baseButtons.TextButton,
                {
                  handleClick: function handleClick() {
                    _this2.props.handleAnchorBibSelected(item);
                  },
                  'data-test-id': 'select-anchor-bib-button' },
                _react2.default.createElement(
                  'span',
                  { 'aria-hidden': true },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_choose_anchor' })
                ),
                _react2.default.createElement(
                  _baseScreenReaderMessage2.default,
                  null,
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'ada_label_select_anchor_bib',
                    values: { title: _react2.default.createElement(_itemScreenReaderDescription2.default, { item: item }) } })
                )
              )
            );
          })
        );
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          searchParams = _props.searchParams,
          intl = _props.intl,
          handleSearch = _props.handleSearch;

      return _react2.default.createElement(
        'div',
        { className: 'cp-anchor-bib-selector' },
        _react2.default.createElement(_searchBar2.default, {
          ref: function ref(el) {
            return _this3._searchBar = el;
          },
          label: intl.formatMessage({ id: 'ada_label_search_if_you_liked' }),
          query: searchParams.get('query'),
          placeholder: intl.formatMessage({ id: 'user_list_readalike_select_anchor' }),
          handleChange: this.handleQueryChange,
          handleSearch: handleSearch }),
        _react2.default.createElement(
          'div',
          { className: 'progress-bar-wrapper' },
          _react2.default.createElement(_sharedProgressBar2.default, { active: searchParams.get('searching') })
        ),
        this.renderSearchResults()
      );
    }
  }]);

  return AnchorBibSelector;
}(_baseBcReactComponent2.default);

AnchorBibSelector.propTypes = {
  searchParams: _reactImmutableProptypes2.default.map,
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  pageSize: _react2.default.PropTypes.number,
  listitems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape).isRequired,

  handleSearch: _react2.default.PropTypes.func.isRequired,
  handleSearchParameterChange: _react2.default.PropTypes.func.isRequired,
  handleAnchorBibSelected: _react2.default.PropTypes.func.isRequired,

  // Injected by manageFocus
  captureFocus: _react2.default.PropTypes.func.isRequired,
  restoreFocus: _react2.default.PropTypes.func.isRequired,

  intl: _reactIntl.intlShape
};

exports.default = (0, _baseAccessibilityManageFocus2.default)((0, _reactIntl.injectIntl)(AnchorBibSelector, { withRef: true }));


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/anchor-bib-selector/components/AnchorBibSelector.component.js
// module id = 1276
// module chunks = 0